var t = /* @__PURE__ */ ((e) => (e.EN_GB = "en-GB", e.EN_US = "en-US", e))(t || {});
const r = {
  bmsNodeId: 11486062,
  countryAbbreviation: "US",
  countryCode: "US",
  countryName: "United States",
  currencyCode: "USD",
  currencySymbol: "$",
  drupalCountryId: 840,
  localeCode: "en-US"
  /* EN_US */
}, u = {
  bmsNodeId: 11486497,
  countryAbbreviation: "UK",
  countryCode: "GB",
  countryName: "United Kingdom",
  currencyCode: "GBP",
  currencySymbol: "£",
  drupalCountryId: 826,
  localeCode: "en-GB"
  /* EN_GB */
}, d = [r, u], y = () => r, a = (e) => d.find((o) => o.localeCode === e) || y(), l = (e, o) => {
  const n = e / 100, c = a(o).currencyCode;
  return new Intl.NumberFormat(o, {
    style: "currency",
    currency: c
  }).format(n);
};
export {
  t as LocaleCode,
  l as formatPrice,
  a as getLocaleFromCode
};
